import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, Spinner, SpinnerSize } from 'office-ui-fabric-react';

const MetaDataButtons = ({ updateHearingMetaData, isUpdatingHearing }) => {
  const { t: translator } = useTranslation();

  return (
    <div className="create-hearing-form-btns">
      <div className="create-hearing-form-btn-spinner">
        <PrimaryButton
          data-automation-id="test"
          text={translator('global.saveAndContinue')}
          onClick={updateHearingMetaData}
          disabled={isUpdatingHearing}
        />
        {isUpdatingHearing && <Spinner size={SpinnerSize.medium} />}
      </div>
    </div>
  );
};

export { MetaDataButtons };
